import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'

import { useAuthorization } from '../../containers/AuthProvider/AuthProvider.hook'

/**
 * The ProtectByProfile component.
 */
const ProtectByProfile = ({
  children,
  fallback = () => null,
  redirectTo = '',
  rule = () => true
}) => {
  const { userType } = useAuthorization()
  const navigate = useNavigate()
  const isAllowed = rule(userType)

  useEffect(() => {
    if (!isAllowed && redirectTo) {
      navigate(redirectTo)
    }
  }, [isAllowed, navigate, redirectTo])

  if (!isAllowed) {
    return fallback()
  }

  return <>{children}</>
}

ProtectByProfile.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.func,
  redirectTo: PropTypes.string,
  rule: PropTypes.func
}

export default ProtectByProfile
